import React from 'react'
import { createPortal } from 'react-dom'
import { FormattedMessage } from 'react-intl'
import { Progress } from 'antd'
import { CheckOutlined, CompassOutlined } from '@ant-design/icons'
import cn from 'classnames'

import { GROUP_COUNT } from './steps'
import styles from './financeOnboarding.module.scss'

const GROUPS = Array.from({ length: GROUP_COUNT }, (_, i) => i + 1)
const RING_COLOR = { '0%': '#6c98f8', '100%': '#4677f3' }

const formatPct = (p) => <span className={styles.railPct}>{p}%</span>

// Indikator progres: identitas panduan, 3 langkah bersambung, dan cincin persen. Tidak bisa diklik.
const ProgressRail = ({ group, pct }) =>
  createPortal(
    <div className={styles.rail} aria-live="polite">
      <span className={styles.railBrand}>
        <span className={styles.railIcon}>
          <CompassOutlined />
        </span>
        <span className={styles.railTitle}>
          <FormattedMessage id="financeOnboarding.rail_title" />
        </span>
      </span>
      <span className={styles.railDivider} />
      <span className={styles.track}>
        {GROUPS.map((n) => (
          <React.Fragment key={n}>
            {n > 1 && <span className={cn(styles.link, n <= group && styles.linkDone)} />}
            <span
              className={cn(
                styles.node,
                n === group && styles.nodeActive,
                n < group && styles.nodeDone,
              )}
            >
              <span className={styles.nodeDot}>{n < group ? <CheckOutlined /> : n}</span>
              <span className={styles.nodeLabel}>
                <FormattedMessage id={`financeOnboarding.rail_step${n}`} />
              </span>
            </span>
          </React.Fragment>
        ))}
      </span>
      <span className={styles.railDivider} />
      <Progress
        type="circle"
        size={36}
        percent={pct}
        strokeWidth={10}
        strokeColor={RING_COLOR}
        trailColor="#e4e9f0"
        format={formatPct}
        className={styles.railRing}
      />
      <span className="sr-only">{`${group}/${GROUP_COUNT}`}</span>
    </div>,
    document.body,
  )

export default ProgressRail
